<template>
  <div class="note-card">
    <img :src="note.bookCover" :alt="note.bookName" class="book-cover" />
    <div class="book-info">
      <div class="header">
        <div class="book-name">{{ note.bookName }}</div>
        <div class="note-info">
          <span class="note-time">笔记时间：{{ note.bookNoteTime }}</span>
          <span class="note-from">来自：{{ note.from }}</span>
          <div>
            <img
              :src="require('@/assets/images/icons/edit.png')"
              alt="编辑"
              class="tool-button"
              @click="handleEditNote"
              title="浏览笔记"
            />
            <img
              :src="require('@/assets/images/icons/delete.png')"
              alt="删除"
              class="tool-button"
              @click="handleDeleteNote"
              title="删除笔记"
            />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content-item">
          <img
            :src="require('@/assets/images/userPage/user.png')"
            class="content-item-icon"
          />
          <span class="note-lable">著者</span
        ><b>：</b><span class="note-content">{{ note.bookAuthor }}</span>
          <!-- 著者：{{ note.bookAuthor }} -->
        </div>
        <div class="content-item">
          <img
            :src="require('@/assets/images/userPage/book.png')"
            class="content-item-icon"
          />
          <span class="note-lable">版本</span
        ><b>：</b><span class="note-content">{{ note.bookEdition }}</span>
          <!-- 版本：{{ note.bookEdition }} -->
        </div>
        <div class="content-item">
          <img
            :src="require('@/assets/images/userPage/note.png')"
            class="content-item-icon"
          />
          <span class="note-lable">笔记</span
        ><b>：</b><span class="note-content">{{ note.bookNote}}</span>
          <!-- 笔记：{{ note.bookNote }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteCard',
  props: {
    note: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    handleEditNote () {
      this.$emit('editNote', this.note)
      // this.$router.push('/bookDetail')
    },
    handleDeleteNote () {
      this.$emit('deleteNote', this.note.id)
    }
  }
}
</script>

<style scoped>
.note-card {
  background-color: #fcfcfc;
  border: 1px solid #f4f2f1;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
}

.note-card .book-cover {
  width: 104px;
  height: 147px;
  margin-right: 27px;
}

.note-card .book-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  flex: 1;
}

.note-card .book-info .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.note-card .book-info .header .book-name {
  font-size: 18px;
  color: #9e5c1d;
  font-weight: bold;
}

.note-card .book-info .header .note-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #9e5c1d;
}

.note-card .book-info .header .note-info .note-time {
  margin-right: 26px;
}

.note-card .book-info .header .note-info .note-from {
  margin-right: 26px;
}

.note-card .book-info .header .note-info .tool-button {
  height: 25px;
  margin-left: 9px;
  cursor: pointer;
}

.note-card .book-info .content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 25px;
  height: 100%;
}

.note-card .book-info .content .content-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #634c37;
  margin-bottom: 10px;
}

.note-card .book-info .content .content-item .content-item-icon {
  width: 18px;
  height: 18px;
  margin-right: 7px;
}
.note-lable {
  width: 36px;
  text-align: justify;
  text-align-last: justify;
}

.note-content {
  margin-left: 5px;
  text-indent: 10px; 
  width: 640px;
  text-align: left;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/NoteCard.vue